import React from 'react'
import { ICharacterItem } from '../../../../../../../../../../api/types/character'
import { useInvalidatingMutation } from '../../../../../../../../../../hooks/useInvalidatingMutation'
import { AxiosResponse } from 'axios'
import {
  mutationEquipCharacterItem,
  mutationUnequipCharacterItem,
} from '../../../../../../../../../../api/mutations'
import {
  characterInventoryQueryKey,
  characterQueryKey,
  gameCharsQueryKey,
} from '../../../../../../../../../../api/queries'
import { IEquipItem } from '../../../../../../../../../../api/types/item'
import { ActionIconButton } from '../../../../../../../../../../components/ActionIconButton/ActionIconButton'
import { Tooltip } from '@mui/material'
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew'
import { ConfirmationDialog } from '../../../../../../../../../../components/ConfirmationDialog/ConfirmationDialog'

export const CharacterEquipItem: React.FC<{
  character_item: ICharacterItem
  game_id: number
}> = ({ character_item, game_id }) => {
  const { mutate, isLoading } = useInvalidatingMutation<AxiosResponse, IEquipItem>(
    item =>
      character_item.equipped
        ? mutationUnequipCharacterItem(item)
        : mutationEquipCharacterItem(item),
    [
      characterInventoryQueryKey(character_item.character_id),
      gameCharsQueryKey(game_id),
      characterQueryKey(character_item.character_id),
    ]
  )

  return (
    <>
      {character_item.item.equip_slot && (
        <ConfirmationDialog
          body={
            <div>
              {character_item.equipped ? 'Ściągnąć' : 'Założyć'}
              {' przedmiot '}
              <strong>{character_item.item.name}</strong>
              {'?'}
            </div>
          }
        >
          {(confirm: any) => (
            <ActionIconButton disabled={isLoading}>
              <Tooltip title="Załóż/ściągnij">
                <AccessibilityNewIcon
                  onClick={confirm(
                    (e: any) => () =>
                      new Promise(r => {
                        mutate({
                          game_id: game_id,
                          character_id: character_item.character_id,
                          character_item_id: character_item.id,
                        })
                        return r('ok')
                      })
                  )}
                />
              </Tooltip>
            </ActionIconButton>
          )}
        </ConfirmationDialog>
      )}
    </>
  )
}
